import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_SPOT_ANALYSIS',
    manual: true,
  });

  useEffect(() => {
    if (
      params.mach_oids === '' ||
      params.mach_oids === undefined ||
      params.start_time === '' ||
      params.end_time === ''
    ) {
    } else {
      let url = `/api/spot/check/craft/list`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) url += '?';
        else url += '&';
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return data || [];
});
